<template>
  <div class="login-container">
    <div class="login-form">
      <h2 class="title">驾校学员预约系统</h2>
      <el-form :model="loginForm" :rules="loginRules" ref="loginForm" class="form">
        <el-form-item prop="username">
          <el-input
              v-model="loginForm.username"
              placeholder="用户名或手机号"
              prefix-icon="el-icon-user"
              size="medium"
          ></el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
              v-model="loginForm.password"
              type="password"
              placeholder="密码"
              prefix-icon="el-icon-lock"
              size="medium"
              @keyup.enter.native="handleLogin"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
              type="primary"
              size="medium"
              :loading="loading"
              @click="handleLogin"
              class="login-btn"
          >
            {{ loading ? '登录中...' : '登录' }}
          </el-button>
        </el-form-item>
      </el-form>
      <div class="links">
        <span>还没有账号？</span>
        <el-link type="primary" @click="$router.push('/register')">立即注册</el-link>
      </div>
    </div>
  </div>
</template>

<script>
import { authAPI } from '../services/api'

export default {
  name: 'UserLogin',
  data() {
    // 手机号验证规则
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入用户名或手机号'))
      }

      // 如果是手机号格式，进行验证
      if (this.isPhoneNumber(value)) {
        const cleanValue = value.trim().replace(/[\s\-+]/g, '')
        if (!/^1[3-9]\d{9}$/.test(cleanValue)) {
          callback(new Error('手机号格式不正确'))
        } else {
          callback()
        }
      } else {
        // 用户名验证
        if (value.length < 3) {
          callback(new Error('用户名长度不能少于3位'))
        } else {
          callback()
        }
      }
    }

    return {
      loading: false,
      isMobile: false,
      messagePosition: 'top-right',
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { validator: validateUsername, trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, message: '密码长度不能少于6位', trigger: 'blur'}
        ]
      }
    }
  },
  mounted() {
    this.checkIsMobile()
    window.addEventListener('resize', this.checkIsMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIsMobile)
  },
  methods: {
    checkIsMobile() {
      const width = window.innerWidth
      this.isMobile = width <= 768

      if (width <= 480) {
        this.messagePosition = 'top'
      } else if (width <= 768) {
        this.messagePosition = 'top'
      } else {
        this.messagePosition = 'top-right'
      }
    },

    showMessage(options) {
      const config = {
        duration: 3000,
        showClose: true,
        ...options
      }

      if (this.isMobile) {
        config.position = 'top'
        config.duration = 2000
      } else {
        config.position = this.messagePosition
      }

      this.$message(config)
    },

    // 判断是否为手机号
    isPhoneNumber(input) {
      if (!input || typeof input !== 'string') return false

      try {
        // 使用 replace 替代 replaceAll，确保兼容性
        const cleanInput = input.trim().replace(/[\s\-()+]/g, '')
        console.log('清理后的输入:', cleanInput)

        // 手机号格式验证
        const isPhone = /^1[3-9]\d{9}$/.test(cleanInput)
        console.log('手机号格式验证结果:', isPhone)

        return isPhone
      } catch (error) {
        console.error('手机号格式验证错误:', error)
        return false
      }
    },

    // 根据角色跳转到对应页面
    redirectByRole(role) {
      const roleRoutes = {
        'student': '/dashboard/reservation',
        'coach': '/dashboard/schedule',
        'admin': '/dashboard/user-management'
      }

      const targetRoute = roleRoutes[role.toLowerCase()] || '/dashboard/reservation'
      // console.log(`用户角色: ${role}, 跳转到: ${targetRoute}`)
      this.$router.push(targetRoute)
    },

    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            console.log('开始登录，凭证:', this.loginForm.username)

            const response = await authAPI.login(this.loginForm)
            console.log('登录响应:', response)

            if (response.success) {
              // 保存token和用户信息
              localStorage.setItem('token', response.data.token)
              localStorage.setItem('userInfo', JSON.stringify({
                username: response.data.username,
                role: response.data.role,
                realName: response.data.realName,
                phone: response.data.phone
              }))

              this.showMessage({
                message: response.message,
                type: 'success'
              })

              // 根据用户角色跳转到对应的页面
              this.redirectByRole(response.data.role)
            } else {
              this.showMessage({
                message: response.message,
                type: 'error'
              })
            }
          } catch (error) {
            console.error('登录错误详情:', error)

            // 详细的错误处理
            if (error.response) {
              const status = error.response.status
              const data = error.response.data

              if (status === 400) {
                this.showMessage({
                  message: data.message || '用户名/手机号或密码错误',
                  type: 'error'
                })
              } else if (status === 401) {
                this.showMessage({
                  message: '认证失败，请重新登录',
                  type: 'error'
                })
              } else if (status === 403) {
                this.showMessage({
                  message: '账号已被禁用，请联系管理员',
                  type: 'error'
                })
              } else if (status === 404) {
                this.showMessage({
                  message: '请求的资源不存在',
                  type: 'error'
                })
              } else if (status >= 500) {
                this.showMessage({
                  message: '服务器内部错误，请稍后重试',
                  type: 'error'
                })
              } else {
                this.showMessage({
                  message: data.message || `请求失败 (${status})`,
                  type: 'error'
                })
              }
            } else if (error.request) {
              this.showMessage({
                message: '网络连接失败，请检查网络设置',
                type: 'error'
              })
            } else {
              this.showMessage({
                message: '登录失败：' + error.message,
                type: 'error'
              })
            }
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style>
/* 基础样式重置 & 全局变量定义 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 主题变量：清爽驾校风格（蓝色系为主） */
:root {
  /* 核心配色 */
  --primary: #2c82e0;
  --primary-hover: #2072d0;
  --primary-light: rgba(44, 130, 224, 0.15);
  --secondary: #409eff;
  /* 文本与背景 */
  --text-dark: #303133;
  --text-light: #606266;
  --text-placeholder: #909399;
  --bg-main: linear-gradient(120deg, #f5f7fa 0%, #e4ebf5 100%);
  --form-bg: #ffffff;
  /* 边框与阴影 */
  --border: #dcdfe6;
  --border-hover: #c0c4cc;
  --shadow-light: 0 4px 20px rgba(0, 0, 0, 0.08);
  --shadow-hover: 0 6px 24px rgba(44, 130, 224, 0.15);
  /* 尺寸与过渡 */
  --radius: 12px;
  --input-radius: 8px;
  --form-width: 380px;
  --form-width-mobile: 92%;
  --transition: all 0.3s ease;
}

/* 深色模式适配 - 纯黑主题 */
/*@media (prefers-color-scheme: dark) {
  :root {
    --primary: #409eff;
    --primary-hover: #5cb3fd;
    --primary-light: rgba(64, 158, 255, 0.2);
    --text-dark: #f0f0f0;
    --text-light: #b0b0b0;
    --text-placeholder: #888888;
    --bg-main: #000000;
    --form-bg: #121212;
    --border: #333333;
    --border-hover: #555555;
    --shadow-light: 0 4px 20px rgba(0, 0, 0, 0.5);
  }

  !* 登录容器背景 *!
  .login-container {
    background: var(--bg-main);
  }

  !* 表单卡片背景 *!
  .login-form {
    background: var(--form-bg);
    border: 1px solid #333333;
  }

  !* 输入框特化样式 - 黑色背景 *!
  .el-input__inner {
    background-color: #0a0a0a !important;
    border-color: var(--border);
    color: var(--text-dark);
  }

  !* 输入框聚焦效果 *!
  .el-input__inner:focus {
    background-color: #0a0a0a !important;
    border-color: var(--primary);
    box-shadow: 0 0 0 2px var(--primary-light);
  }

  !* 前缀图标颜色 - 蓝色（增加特异性） *!
  .login-container .login-form .el-input__prefix,
  .login-container .login-form .el-input .el-input__prefix,
  .login-container .login-form .el-input__prefix i {
    color: var(--primary) !important;
  }

  !* 输入框占位符 *!
  .el-input__inner::placeholder {
    color: var(--text-placeholder);
  }

  !* 按钮样式调整 *!
  .login-btn {
    background: var(--primary);
  }

  .login-btn:hover {
    background: var(--primary-hover);
  }

  !* 链接颜色 *!
  .links .el-link {
    color: var(--primary);
  }

  .links .el-link:hover {
    color: var(--primary-hover);
  }

  !* 装饰元素调整 *!
  .login-container::before,
  .login-container::after {
    background: var(--primary-light);
  }
}*/

/* 高对比度模式支持 */
@media (prefers-contrast: high) {
  :root {
    --primary: #0066cc;
    --primary-hover: #0077ee;
    --border: #000000;
  }
  .login-form {
    border: 2px solid var(--border);
  }
  .title::after {
    background: var(--primary);
    height: 4px;
  }
  .el-input__inner {
    border-width: 2px;
  }
}

/* 减少动画偏好支持 */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
  .login-form:hover, .login-btn:hover {
    transform: none !important;
  }
}

/* 登录页面主容器 */
.login-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--bg-main);
  padding: 20px;
  position: relative;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  overflow: hidden;
}

/* 背景轻装饰元素（提升层次感） */
.login-container::before,
.login-container::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  background: var(--primary-light);
  z-index: 0;
  opacity: 0.8;
}
.login-container::before {
  width: 200px;
  height: 200px;
  top: 10%;
  right: 12%;
}
.login-container::after {
  width: 150px;
  height: 150px;
  bottom: 15%;
  left: 10%;
}

/* 登录表单卡片 */
.login-form {
  width: var(--form-width);
  padding: 36px 32px;
  background: var(--form-bg);
  border-radius: var(--radius);
  box-shadow: var(--shadow-light);
  position: relative;
  z-index: 1;
  transition: var(--transition);
  max-width: 100%;
  backdrop-filter: blur(8px);
}

/* 表单hover交互效果 */
.login-form:hover {
  box-shadow: var(--shadow-hover);
  transform: translateY(-3px);
}

/* 标题样式 */
.title {
  text-align: center;
  margin-bottom: 30px;
  color: var(--text-dark);
  font-size: 22px;
  font-weight: 600;
  position: relative;
  padding-bottom: 12px;
  line-height: 1.4;
}

.title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: var(--primary);
  border-radius: 2px;
  transition: var(--transition);
}

.login-form:hover .title::after {
  width: 80px;
}

/* 表单区域间距 */
.form {
  margin-bottom: 26px;
}

/* 表单项间距 */
.el-form-item {
  margin-bottom: 24px;
}

/* === 输入框基础样式（与注册页面保持一致）=== */
.el-input__inner {
  border: 1px solid var(--border);
  border-radius: var(--input-radius);
  padding: 12px 15px 12px 40px;
  font-size: 14px;
  color: var(--text-dark);
  background: var(--form-bg);
  transition: var(--transition);
  height: 44px;
}

/* 输入框聚焦样式（与注册页面保持一致） */
.el-input__inner:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 2px var(--primary-light);
  outline: none;
}

/* 输入框前缀图标颜色 - 蓝色（使用更具体的选择器覆盖默认样式） */
.login-container .login-form .el-input__prefix,
.login-container .login-form .el-input .el-input__prefix,
.login-container .login-form .el-input__prefix i {
  color: var(--primary) !important;
  font-size: 16px;
  transition: var(--transition);
}

/* 输入框聚焦时图标颜色变深 */
.login-container .login-form .el-input__inner:focus + .el-input__prefix,
.login-container .login-form .el-input__inner:hover + .el-input__prefix {
  color: var(--primary-hover) !important;
}

/* 输入框占位符样式（与注册页面保持一致） */
.el-input__inner::placeholder {
  color: var(--text-placeholder);
}

/* 登录按钮样式 */
.login-btn {
  width: 100%;
  height: 44px;
  background: var(--primary);
  border: none;
  border-radius: var(--input-radius);
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  transition: var(--transition);
  position: relative;
  overflow: hidden;
}

/* 按钮流光效果 - 与注册页面保持一致 */
.login-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
  transition: left 0.5s ease;
}

.login-btn:hover::before {
  left: 100%;
}

/* 按钮hover/active效果 - 与注册页面保持一致 */
.login-btn:hover {
  background: var(--primary-hover);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px var(--primary-light);
}

.login-btn:active {
  transform: translateY(0);
}

/* 按钮加载状态样式 */
.el-button--primary.is-loading {
  opacity: 0.9;
}

/* 加载动画样式优化 */
.el-loading-spinner .circular {
  animation: loading-rotate 2s linear infinite;
}
.el-loading-spinner .path {
  animation: loading-dash 1.5s ease-in-out infinite;
  stroke: var(--primary);
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  stroke-width: 2;
}
@keyframes loading-rotate {
  100% { transform: rotate(360deg); }
}
@keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px;
  }
}

/* 链接区域样式 */
.links {
  text-align: center;
  font-size: 14px;
  color: var(--text-light);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
}

/* 注册链接样式 */
.links .el-link {
  color: var(--primary);
  transition: var(--transition);
  font-weight: 500;
}
.links .el-link:hover {
  color: var(--primary-hover);
  transform: translateX(2px);
}

/* 表单错误状态增强（与注册页面保持一致） */
.el-form-item.is-error .el-input__inner {
  border-color: #f56c6c;
  box-shadow: 0 0 0 2px rgba(245, 108, 108, 0.15);
}

/* 焦点可见性增强（无障碍）（与注册页面保持一致） */
.el-input__inner:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

/* 响应式适配 - 平板/小屏 */
@media (max-width: 768px) {
  .login-form {
    width: var(--form-width-mobile);
    padding: 32px 28px;
  }
  .title {
    font-size: 20px;
    margin-bottom: 26px;
  }
  .el-form-item {
    margin-bottom: 20px;
  }
  .el-input__inner {
    height: 42px;
    padding: 10px 14px 10px 36px;
  }
  .login-btn {
    height: 42px;
    font-size: 15px;
  }
}

/* 响应式适配 - 手机 */
@media (max-width: 480px) {
  .login-container {
    padding: 15px;
  }
  .login-form {
    padding: 28px 24px;
  }
  .title {
    font-size: 18px;
    margin-bottom: 22px;
  }
  .form {
    margin-bottom: 20px;
  }
  .el-form-item {
    margin-bottom: 18px;
  }
  .el-input__inner {
    height: 40px;
    padding: 10px 12px 10px 34px;
  }
  .login-btn {
    height: 40px;
    font-size: 14px;
  }
  .links {
    flex-direction: column;
    gap: 8px;
  }
}

/* 响应式适配 - 超小屏 */
@media (max-width: 360px) {
  .login-form {
    padding: 24px 20px;
  }
  .title {
    font-size: 17px;
  }
}

/* 移动端消息提示优化 */
@media (max-width: 768px) {
  .el-message {
    width: 90% !important;
    min-width: auto !important;
    max-width: 320px !important;
    margin: 0 auto !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    border-radius: 10px !important;
    box-shadow: 0 6px 16px rgba(0,0,0,0.15) !important;
  }
  .el-message--top {
    top: 20px !important;
  }
  .el-message__content {
    font-size: 15px !important;
    line-height: 1.4 !important;
    text-align: center !important;
  }
  .el-message .el-icon-close {
    font-size: 16px !important;
    right: 12px !important;
    top: 12px !important;
  }
}

@media (max-width: 480px) {
  .el-message {
    width: 95% !important;
    max-width: 280px !important;
    padding: 14px 16px !important;
  }
  .el-message__content {
    font-size: 14px !important;
    padding-right: 24px !important;
  }
  .el-message .el-icon-close {
    right: 10px !important;
    top: 10px !important;
  }
  .el-message--top {
    top: 15px !important;
  }
}
</style>
